function DevToolbar({ devTier, setDevTier, devOptions }) {
  return (
    <div style={{
      background: "#1a1625",
      borderBottom: "2px solid #7c3aed",
      padding: "6px 16px",
      display: "flex",
      alignItems: "center",
      gap: 8,
      fontFamily: "'Inter', sans-serif",
      fontSize: "0.75rem",
      zIndex: 9999,
      position: "sticky",
      top: 0,
    }}>
      <span style={{ color: "#a78bfa", fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", marginRight: 8 }}>
        DEV
      </span>
      <span style={{ color: "#9ca3af", marginRight: 4 }}>View as:</span>
      {devOptions.map(opt => {
        const isActive = devTier === opt.value;
        return (
          <button
            key={opt.label}
            onClick={() => setDevTier(opt.value)}
            style={{
              background: isActive ? "#7c3aed" : "rgba(255,255,255,0.06)",
              color: isActive ? "#fff" : "#9ca3af",
              border: isActive ? "1px solid #7c3aed" : "1px solid rgba(255,255,255,0.1)",
              borderRadius: 100,
              padding: "4px 12px",
              fontSize: "0.72rem",
              fontWeight: isActive ? 600 : 400,
              cursor: "pointer",
              fontFamily: "'Inter', sans-serif",
              transition: "all 0.15s ease",
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export { DevToolbar };
